module.exports = __webpack_public_path__ + "img/pencil-filter-right_cn.0158392.jpg";